"use strict";

const debug = require("debug")("fifi:appService");

export default class Applications {
  constructor(appConfig, $http, $q) {
    "ngInject";

    this._appConfig = appConfig;
    this._$http = $http;
    this._$q = $q;
  }

  query(config) {
    // Create the $http object for this request
    let request = {
      url: `${this._appConfig.api}/applications`,
      method: "GET"
    };

    if (config && (config.type || config.year)) {
      if (!config.type) {
        Reflect.deleteProperty(config, "type");
      }
      if (!config.year) {
        Reflect.deleteProperty(config, "year");
      }
      request.params = config;
    }

    if (config && config.id) {
      request.url = `${this._appConfig.api}/applications/${config.id}`;
    }

    debug(request);
    return this._$http(request).then(res => res.data);
  }

  save(application) {
    let request = {};

    if (application._id) {
      request.url = `${this._appConfig.api}/applications/${application._id}`;
      request.method = "PUT";
    } else {
      request.url = `${this._appConfig.api}/applications`;
      request.method = "POST";
    }

    request.data = application;

    return this._$http(request).then(res => res.data);
  }

  manual(application) {
    let request = {};

    request.url = `${this._appConfig.api}/applications/manual`;
    request.method = "POST";

    request.data = application;

    return this._$http(request).then(res => res.data);
  }

  note(application) {
    let request = {};

    request.url = `${this._appConfig.api}/applications/note`;
    request.method = "POST";

    request.data = application;

    return this._$http(request).then(res => res.data);
  }

  wait(application) {
    let request = {};

    request.url = `${this._appConfig.api}/applications/wait`;
    request.method = "POST";

    request.data = application;

    return this._$http(request).then(res => res.data);
  }

  mailingList(application) {
    let request = {};

    request.url = `${this._appConfig.api}/applications/mailingList`;
    request.method = "POST";

    request.data = application;

    return this._$http(request).then(res => res.data);
  }

  payAndAccept(application) {
    let request = {};

    request.url = `${this._appConfig.api}/applications/pay/${application._id}`;
    request.method = "PUT";

    request.data = application;

    return this._$http(request).then(res => res.data);
  }

  acceptSpecial(application) {
    let request = {};

    request.url = `${this._appConfig.api}/applications/special/${application._id}`;
    request.method = "PUT";

    request.data = application;

    return this._$http(request).then(res => res.data);
  }

  refund(application) {
    let request = {};

    request.url = `${this._appConfig.api}/applications/refund/${application._id}`;
    request.method = "PUT";

    request.data = application;

    return this._$http(request).then(res => res.data);
  }

  capture(application) {
    let request = {};

    request.url = `${this._appConfig.api}/applications/accept/${application._id}`;
    request.method = "PUT";

    request.data = application;

    return this._$http(request).then(res => res.data);
  }

  stats() {
    let request = {
      url: `${this._appConfig.api}/applications/stats`,
      method: "GET"
    };
    return this._$http(request).then(res => res.data);
  }

  report(config) {
    let request = {
      url: `${this._appConfig.api}/applications/report`,
      method: "GET"
    };

    if (config && (config.type || config.year)) {
      if (!config.type) {
        Reflect.deleteProperty(config, "type");
      }
      if (!config.year) {
        Reflect.deleteProperty(config, "year");
      }
      request.params = config;
    }

    return this._$http(request).then(res => res.data);
  }

  homeowner(config) {
    let request = {
      url: `${this._appConfig.api}/applications/homeowner`,
      method: "GET"
    };

    if (config) {
      request.params = config;
    }

    return this._$http(request).then(res => res.data);
  }

  stickers(config) {
    let request = {
      url: `${this._appConfig.api}/applications/stickers`,
      method: "GET"
    };

    if (config && (config.type || config.year)) {
      if (!config.type) {
        Reflect.deleteProperty(config, "type");
      }
      if (!config.year) {
        Reflect.deleteProperty(config, "year");
      }
      if (!config.update) {
        Reflect.deleteProperty(config, "update");
      }
      request.params = config;
    }

    return this._$http(request).then(res => res.data);
  }

  assignIds(config) {
    let request = {
      url: `${this._appConfig.api}/applications/assignIds`,
      method: "GET"
    };

    if (config) {
      request.params = config;
    }

    return this._$http(request).then(res => res.data);
  }

  sendAllIds(config) {
    let request = {
      url: `${this._appConfig.api}/applications/sendAllIds`,
      method: "GET"
    };

    if (config) {
      request.params = config;
    }

    return this._$http(request).then(res => res.data);
  }

  sendId(id) {
    let request = {
      url: `${this._appConfig.api}/applications/sendId/${id}`,
      method: "GET"
    };

    return this._$http(request).then(res => res.data);
  }
}



// WEBPACK FOOTER //
// ./client/components/services/applications.service.js